export enum SoccerGoalAttribute {
  OwnGoal = 397,
  PenaltyGoal = 398,
  BigChanceSuccessful = 898,
  LeftFoot = 400,
  RightFoot = 401,
  OtherBodyPart = 732,
  Volley = 733,
  BicycleKick = 734,
  Chip = 735,
  OneOnOne = 736,
  DirectFreeKick = 402,
  InsidePenaltyArea = 415,
  OutsidePenaltyArea = 416,
  Head = 417,
  AfterCorner = 418,
  AfterFastAttack = 419,
  AfterPositionalAttack = 420,
  UpperLeft = 421,
  UpperRight = 422,
  UpperMiddle = 423,
  BottomMiddle = 424,
  BottomLeft = 425,
  BottomRight = 426,
  Crossbar = 737,
  Post = 738,
  PowerShot = 843,
  GoalkeeperInvolvement = 893,
  Normal = 899,
  FirstTouch = 900,
  NoPressure = 901,
  LightPressure = 902,
  HighPressure = 903,
  ClearPosition = 904,
  OneDefender = 905,
  TwoOrMoreDefenders = 906,
  UncomfortablePosition = 907,
  EmptyNet = 908,
  OpenPlay = 3037,
  FastBreak = 3038,
  SetPiece = 3039,
  NoAssist = 3040,
}
